import { BrandConfig, brandConfigs } from '@blockpulse3/data/shared';

export const Theme: BrandConfig['theme'] = brandConfigs.cenitz.theme;
